import { Tooltip } from 'bootstrap'; // Importa Tooltip da Bootstrap

function initTooltip(selector = '[data-bs-toggle="tooltip"]') {
    // Trova tutti gli elementi con il selettore specificato
    const tooltipTriggerList = document.querySelectorAll(selector);

    // Inizializza i tooltip per ciascun elemento
    const tooltipList = Array.from(tooltipTriggerList).map((tooltipTriggerEl) => {
        return new Tooltip(tooltipTriggerEl); // Crea una nuova istanza di Tooltip
    });

    // Ritorna l'elenco di tooltip inizializzati (facoltativo)
    return tooltipList;
}

export default initTooltip;